import { Reducer } from 'redux';
import { getType } from '@anm/helpers/saga/typesafe-actions';

import { triggerPosterStatus, uploadCustomPosterAsync } from '../actions';
import { HostedVideoActions } from '../types';

import { initialHostedVideoState } from './index';

const uploadPosterReducer: Reducer<
  typeof initialHostedVideoState,
  HostedVideoActions
> = (state = initialHostedVideoState, action) => {
  switch (action.type) {
    case getType(uploadCustomPosterAsync.request): {
      const params = action.payload;

      return {
        ...state,
        uploadPoster: {
          ...state.uploadPoster,
          params,
          isPending: true,
          isError: false
        }
      };
    }
    case getType(uploadCustomPosterAsync.success): {
      const newPoster = state.videoData?.poster;

      return {
        ...state,
        uploadPoster: {
          ...state.uploadPoster,
          isPending: false,
          isError: false,
          error: null
        },
        videoData: {
          ...state.videoData!,
          savedData: {
            ...state.videoData?.savedData!,
            ...(newPoster && { poster: newPoster })
          }
        }
      };
    }
    case getType(uploadCustomPosterAsync.failure): {
      const error = action.payload;
      return {
        ...state,
        uploadPoster: {
          ...state.uploadPoster,
          error,
          isPending: false,
          isError: true
        }
      };
    }
    case getType(triggerPosterStatus): {
      return {
        ...state,
        uploadPoster: {
          ...state.uploadPoster,
          posterStatus: !state.uploadPoster.posterStatus
        }
      };
    }
    default:
      return state;
  }
};

export default uploadPosterReducer;
